import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { type FrankfurtCardOffer } from "../types";

interface FrankfurtCardOfferSelectionProps {
  offers: FrankfurtCardOffer[];
  selectedOffer: FrankfurtCardOffer | null;
  onSelectOffer: (offer: FrankfurtCardOffer) => void;
}

// Only two options (1 day / 2 days), so plain tiles instead of the Munich City Pass carousel.
export default function FrankfurtCardOfferSelection({
  offers,
  selectedOffer,
  onSelectOffer
}: FrankfurtCardOfferSelectionProps) {
  const { t } = useTranslation();

  return (
    <Box mt={{ xs: 3, sm: 2 }} mb={1}>
      <Box className="frankfurt-card-quick-selection-title">{t("transport.frankfurtCard.offerSectionTitle")}</Box>
      <Box className="frankfurt-card-quick-selection" ml={{ xs: 2, sm: 1 }} mr={{ xs: 2, sm: 1 }}>
        {offers.map(offer => (
          <Box
            key={offer?.offer_code}
            role="button"
            aria-pressed={offer?.offer_code === selectedOffer?.offer_code}
            className={`frankfurt-card-quick-selection-item ${
              offer?.offer_code === selectedOffer?.offer_code ? "frankfurt-card-quick-selection-item__active" : ""
            }`}
            onClick={() => onSelectOffer(offer)}
            data-cy={`frankfurt-card-offer-${offer?.offer_code}`}
          >
            {offer?.name}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
